export enum CashbackStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}
